var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonBook = function SvgButtonBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    preserveAspectRatio: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE41",
    d: "M28.22 5.45S21.6 1 15 5.35c0 0-1.86-3.24-13.07-1.77 0 0 .68 12.08-.69 21.49 0 0 11.38-2.13 13.76 2.06 0 0 5.21-5.43 13.67-1.07a200 200 0 0 0-.45-20.61m-23.41 7c4.51-.64 7.19.55 8.19 1.1v1.77c-3-1.25-7.54-1-8.1-.93ZM13 7.7v1.91a19 19 0 0 0-8.22-.49V6.6A20.3 20.3 0 0 1 13 7.7M4.54 21.46l.27-3a19.1 19.1 0 0 1 8.06 1v2.28c-3.21-1.28-6.87-.52-8.33-.28m12.82-8a18.7 18.7 0 0 1 8.75-.05l-.07 2a30 30 0 0 0-8.61-.16Zm8.88-6-.07 1.94a23.3 23.3 0 0 0-9-.13l-.06-1.9c2.95-1.48 5.56-.57 9.13.08Zm-8.59 14-.06-1.81a22.1 22.1 0 0 1 8.32-.65l-.08 2.38a20.9 20.9 0 0 0-8.18.08",
    "data-name": "Header Buttons"
  })));
};
export default SvgButtonBook;